import React, { useCallback, useEffect, useState } from 'react'
import { isNil } from '../../../services/common'
import { ENV } from '../../../services/constant'
import { icon } from '../../../services/icon'

const InputSearch = ({ hearing, value, setValue, api }) => {
    const [message, setMessage] = useState('')
    const params = new URLSearchParams(window.location.search)
    const query = params.get('q')
    const homeUrl = ENV?.wp?.home_url

    const onSubmit = useCallback(
        (e) => {
            e.preventDefault()
            if (!isNil(value)) {
                window.location.href = `${homeUrl}/sp/${hearing}/recherche?q=${value}`
            } else {
                setMessage('Veuillez saisir une recherche')
            }
        },
        [value, homeUrl, hearing]
    )

    const fetchApi = useCallback(
        (value) => {
            api.searchGet(hearing, value)
        },
        [hearing, value, api]
    )

    useEffect(() => {
        if (query) {
            setValue(query)
            fetchApi(query)
        }
    }, [query])

    return (
        <div>
            <form className="baseocom-input-search" onSubmit={onSubmit}>
                <input
                    value={value || ''}
                    placeholder="Rechercher une fiche pratique, une démarche, ..."
                    onChange={(e) => setValue(e.target.value)}
                />

                <button type="submit">{icon('magnifying-glass', '20')}</button>
            </form>
            <div className="baseocom-error">{message}</div>
        </div>
    )
}

export default InputSearch
